import { render } from "./AppLayoutWithSidebar.vue?vue&type=template&id=ff491d2e&scoped=true"
import script from "./AppLayoutWithSidebar.vue?vue&type=script&lang=js"
export * from "./AppLayoutWithSidebar.vue?vue&type=script&lang=js"

import "./AppLayoutWithSidebar.vue?vue&type=style&index=0&id=ff491d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff491d2e"]])

export default __exports__